<div class="row" id="privacyComponent">
  <div class="col-lg-10 mx-auto">
    <h1 class="my-4">{{ 'LEGAL.'+ clientId + '.' + privacy + '.TITLE' | translate }}</h1>
    <main class="legal">
      <section>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.0.PARAGRAPH.1' | translate }}</p>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.0.PARAGRAPH.2' | translate }}</p>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.0.PARAGRAPH.3' | translate }}</p>
      </section>
      <section>
        <h5>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.1.TITLE' | translate }}</h5>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.1.PARAGRAPH.1' | translate }}</p>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.1.LIST.ITEM.1.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.1.LIST.ITEM.1.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.1.LIST.ITEM.2.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.1.LIST.ITEM.2.TEXT' | translate)"></div>
        </article>
      </section>
      <section>
        <h5>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.TITLE' | translate }}</h5>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.PARAGRAPH.1' | translate }}</p>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.PARAGRAPH.2' | translate }}</p>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.LIST.ITEM.1.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.LIST.ITEM.1.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.LIST.ITEM.2.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.LIST.ITEM.2.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.LIST.ITEM.3.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.2.LIST.ITEM.3.TEXT' | translate)"></div>
        </article>
      </section>
      <section>
        <h5>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.TITLE' | translate }}</h5>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.PARAGRAPH.1' | translate }}</p>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.1.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.1.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.2.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.2.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.3.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.3.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.4.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.LIST.ITEM.4.TEXT' | translate)"></div>
        </article>
        <br>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.PARAGRAPH.2' | translate }}</p>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.3.PARAGRAPH.3' | translate }}</p>
      </section>
      <section>
        <h5>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.TITLE' | translate }}</h5>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.PARAGRAPH.1' | translate }}</p>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.LIST.ITEM.1.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.LIST.ITEM.1.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.LIST.ITEM.2.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.LIST.ITEM.2.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.LIST.ITEM.3.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.4.LIST.ITEM.3.TEXT' | translate)"></div>
        </article>
      </section>
      <section>
        <h5>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.5.TITLE' | translate }}</h5>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.5.PARAGRAPH.1' | translate }}</p>
      </section>
      <section>
        <h5>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.TITLE' | translate }}</h5>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.PARAGRAPH.1' | translate }}</p>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.PARAGRAPH.2' | translate }}</p>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.1.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.1.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.2.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.2.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.3.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.3.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.4.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.6.LIST.ITEM.4.TEXT' | translate)"></div>
        </article>
      </section>
      <section>
        <h5>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.TITLE' | translate }}</h5>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.PARAGRAPH.1' | translate }}</p>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.PARAGRAPH.2' | translate }}</p>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.LIST.ITEM.1.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.LIST.ITEM.1.TEXT' | translate)"></div>
        </article>
        <article>
          <h6 [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.LIST.ITEM.2.TITLE' | translate)"></h6>
          <div [innerHTML]="('LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.LIST.ITEM.2.TEXT' | translate)"></div>
        </article>
        <br>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.PARAGRAPH.3' | translate }}</p>
        <p>{{ 'LEGAL.'+ clientId + '.' + privacy + '.SECTION.7.PARAGRAPH.4' | translate }}</p>
      </section>
    </main>

  </div>
</div>
